export default __webpack_public_path__ + "static/media/decorativa1.87f05a93.jpg";